import { EVENT_EMITTERS, type eventPayloads, type EventKey, type EventName } from "@/events";
import { useEffect } from "react";
import {} from "@/types";

export function useEventListener<T extends EventKey, E extends EventName<T>>(
    event: E & string,
    callback: (payload: eventPayloads[T][E]) => void,
) {
    const type = event.split(":")[0] as T;
    const emitter = EVENT_EMITTERS[type];

    useEffect(() => {
        if (!emitter) return;
        emitter.on(event, callback);
        return () => emitter.off(event, callback);
    }, [event, emitter, callback]);
}
